module.exports = __webpack_public_path__ + "static/img/020_9.56d3aae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_9.jpg
// module id = Rq1L
// module chunks = 1